import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class DashboardLayoutApi extends BaseApi {
    constructor(client) {
        super(client, '/dashboard-layout');
    }

    async getLayout(params) {
        try {
            const response = await this.client.get(this.basePath, { params });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async saveLayout(payload) {
        try {
            const response = await this.client.post(`${this.basePath}/save`, payload);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async resetLayout(params) {
        try {
            const response = await this.client.delete(this.basePath, { params });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
